import {createRoot} from 'react-dom/client';

import ApplicationLayout from '@js/components/layouts/application';

require('@js/common');

const root = createRoot(document.getElementById('places-component'));
root.render(
    <ApplicationLayout componentId="places-component">
        {document.getElementById('static-content')?.innerHTML}
    </ApplicationLayout>
);
